import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { redirects as anyRedirects, routes as anyRoutes } from './any';
import { redirects as _loggedInRedirects, routes as _loggedInRoutes } from './logged-in';
import { redirects as _loggedInRedirectsOld, routes as _loggedInRoutesOld } from './logged-in-old';
import { redirects as _loggedOutRedirects, routes as _loggedOutRoutes } from './logged-out';

export type RouteProps = React.ComponentProps<typeof Route> & {
  layout: React.ComponentType<{ children: React.ReactNode }>;
};
export type RedirectProps = React.ComponentProps<typeof Redirect>;

interface RoutesProps {
  notFound: React.ComponentType;
  redirects?: Array<RedirectProps>;
  routes: Array<RouteProps>;
}

export function Routes({ notFound, redirects = [], routes }: RoutesProps) {
  return (
    <Switch>
      {redirects.map(({ from, to }, i) => (
        <Route key={i} path={from} exact render={() => <Redirect from={from} to={to} />} />
      ))}
      {routes.map(({ path, exact, component }, i) => (
        <Route key={i} path={path} exact={!!exact} component={component ? component : notFound} />
      ))}
      <Route component={notFound} />
    </Switch>
  );
}

export { NotFound as NotFoundLoggedIn } from './logged-in-old';
export { NotFound as NotFoundLoggedOut } from './logged-out';

export const loggedInRedirectsWithFlag = _loggedInRedirectsOld.concat(anyRedirects);
export const loggedInRoutesWithFlag = _loggedInRoutesOld.concat(anyRoutes);
export const loggedInRedirectsWithoutFlag = _loggedInRedirects.concat(anyRedirects);
export const loggedInRoutesWithoutFlag = _loggedInRoutes.concat(anyRoutes);
export const loggedOutRedirectsWithFlag = _loggedOutRedirects.concat(anyRedirects);
export const loggedOutRoutesWithFlag = _loggedOutRoutes.concat(anyRoutes);

export { redirects as anyRedirects, routes as anyRoutes } from './any';
